import { EmailsActionTypes } from './email.types';

const setLoading = isLoading => ({ type: EmailsActionTypes.SET_LOADING, payload: { isLoading } });

const getEmailsRequest = () => ({ type: EmailsActionTypes.GET_EMAILS_REQUEST });
const getEmailsSuccess = () => ({ type: EmailsActionTypes.GET_EMAILS_SUCCESS });
const getEmailsFailure = () => ({ type: EmailsActionTypes.GET_EMAILS_FAILURE });

const getDomainsToOfferTitan = () => ({ type: EmailsActionTypes.GET_DOMAINS_TO_OFFER_TITAN });
const getDomainsToOfferTitanSuccess = () => ({ type: EmailsActionTypes.GET_DOMAINS_TO_OFFER_TITAN_SUCCESS });
const getDomainsToOfferTitanFailure = () => ({ type: EmailsActionTypes.GET_DOMAINS_TO_OFFER_TITAN_FAILURE });
const setDomainsToOfferTitan = payload => ({ type: EmailsActionTypes.SET_DOMAINS_TO_OFFER_TITAN, payload });

const emailsActivateRenewalRequest = (email, callBackFunction) => ({
  type: EmailsActionTypes.EMAIL_ACTIVATE_RENEWAL_REQUEST,
  payload: { email, callBackFunction },

});

const emailsActivateRenewalSuccess = () => ({
  type: EmailsActionTypes.EMAIL_ACTIVATE_RENEWAL_SUCCESS,
});

const emailsActivateRenewalFailure = () => ({
  type: EmailsActionTypes.EMAIL_ACTIVATE_RENEWAL_FAILURE,
});

const createEmailTrialRequest = (dataEmail, history) => ({
  type: EmailsActionTypes.EMAIL_CREATE_EMAIL_TRIAL_REQUEST,
  payload: {
    data: dataEmail,
    history,
  },
});

const createEmailTrialSuccess = () => ({
  type: EmailsActionTypes.EMAIL_CREATE_EMAIL_TRIAL_SUCCESS,
});

const createEmailTrialFailure = () => ({
  type: EmailsActionTypes.EMAIL_CREATE_EMAIL_TRIAL_FAILURE,
});

const updateDomainSetupRequest = (dataDomainSetup, callBackFunction) => ({
  type: EmailsActionTypes.UPDATE_DOMAIN_SETUP_REQUEST,
  payload: { dataDomainSetup, callBackFunction },

});

const updateDomainSetupSuccess = () => ({
  type: EmailsActionTypes.UPDATE_DOMAIN_SETUP_SUCCESS,
});

const updateDomainSetupFailure = () => ({
  type: EmailsActionTypes.UPDATE_DOMAIN_SETUP_FAILURE,
});

const getPaymentMethodsRequest = () => ({
  type: EmailsActionTypes.GET_PRO_EMAIL_PAYMENT_METHODS,
});

const getPaymentMethodsRequestSuccess = response => ({
  type: EmailsActionTypes.GET_PRO_EMAIL_PAYMENT_METHODS_SUCCESS,
  payload: { paymentMethods: response },
});

const getPaymentMethodsRequestFailure = () => ({
  type: EmailsActionTypes.GET_PRO_EMAIL_PAYMENT_METHODS_ERROR,
});

const requestTitanPremiumBuy = data => ({
  type: EmailsActionTypes.REQUEST_TITAN_PREMIUM_BUY_FAST_CHECKOUT,
  payload: data,
});

const errorTitanPremiumBuy = () => ({
  type: EmailsActionTypes.ERROR_TITAN_PREMIUM_BUY_FAST_CHECKOUT,
});

const receiveTitanPremiumBuy = response => ({
  type: EmailsActionTypes.RECEIVE_TITAN_PREMIUM_BUY_FAST_CHECKOUT,
  data: response,
});

const abortTitanPremiumBuy = () => ({
  type: EmailsActionTypes.ABORT_TITAN_PREMIUM_BUY_FAST_CHECKOUT,
});

const requestCheckDomainAvailabilityToTitan = ({
  domain, onErrorCallBack, bringSuggestions, recoverFreeDomainId,
}) => ({
  type: EmailsActionTypes.CHECK_DOMAIN_AVAILABILITY_TO_TITAN_REQUEST,
  payload: {
    domain, onErrorCallBack, bringSuggestions, recoverFreeDomainId,
  },
});

const checkDomainAvailabilityToTitanSuccess = ({ code: status, titan_platform_id: titanPlatformId = null, suggestions: tldSuggestions = [] }) => ({
  type: EmailsActionTypes.CHECK_DOMAIN_AVAILABILITY_TO_TITAN_SUCCESS,
  payload: { status, titanPlatformId, tldSuggestions },
});

const checkDomainAvailabilityToTitanFailure = () => ({
  type: EmailsActionTypes.CHECK_DOMAIN_AVAILABILITY_TO_TITAN_FAILURE,
});

const resetTitanDomainAvailabilityFlow = () => ({
  type: EmailsActionTypes.RESET_TITAN_DOMAIN_AVAILABILITY_FLOW,
});

const requestChangeTitanDomain = ({
  domain, callBackFunction, isInternal, platformId, hostingId, onFailureCallBackFunction,
}) => ({
  type: EmailsActionTypes.TITAN_DOMAIN_CHANGE_REQUEST,
  payload: {
    domain, callBackFunction, isInternal, platformId, hostingId, onFailureCallBackFunction,
  },
});

const changeTitanDomainSuccess = () => ({
  type: EmailsActionTypes.TITAN_DOMAIN_CHANGE_SUCCESS,
});

const changeTitanDomainFailure = () => ({
  type: EmailsActionTypes.TITAN_DOMAIN_CHANGE_FAILURE,
});

const getTitanDomainRedeemDataRequest = ({ recoverFreeDomainId }) => ({
  type: EmailsActionTypes.GET_TITAN_DOMAIN_REDEEM_DATA_REQUEST,
  payload: { recoverFreeDomainId },
});

const getTitanDomainRedeemDataSuccess = ({ tlds }) => ({
  type: EmailsActionTypes.GET_TITAN_DOMAIN_REDEEM_DATA_SUCCESS,
  payload: { tlds },
});

const getTitanDomainRedeemDataFailure = () => ({
  type: EmailsActionTypes.GET_TITAN_DOMAIN_REDEEM_DATA_FAILURE,
});

const resetTitanDomainRedeemData = () => ({
  type: EmailsActionTypes.RESET_TITAN_DOMAIN_REDEEM_DATA,
});

const actions = {
  emails: {
    failure: getEmailsFailure,
    request: getEmailsRequest,
    success: getEmailsSuccess,

    createEmailTrial: {
      request: createEmailTrialRequest,
      success: createEmailTrialSuccess,
      failure: createEmailTrialFailure,
    },

    activateRenewal: {
      request: emailsActivateRenewalRequest,
      success: emailsActivateRenewalSuccess,
      failure: emailsActivateRenewalFailure,
    },
    updateDomainSetup: {
      request: updateDomainSetupRequest,
      success: updateDomainSetupSuccess,
      failure: updateDomainSetupFailure,
    },
    loading: {
      set: setLoading,
    },
    paymentMethods: {
      request: getPaymentMethodsRequest,
      success: getPaymentMethodsRequestSuccess,
      failure: getPaymentMethodsRequestFailure,
    },
    buyTitanPremium: {
      request: requestTitanPremiumBuy,
      success: receiveTitanPremiumBuy,
      failure: errorTitanPremiumBuy,
      abort: abortTitanPremiumBuy,
    },
  },

  getDomainsToOfferTitan: {
    request: getDomainsToOfferTitan,
    success: getDomainsToOfferTitanSuccess,
    failure: getDomainsToOfferTitanFailure,
    set: setDomainsToOfferTitan,
  },
  checkDomainAvailabilityToTitan: {
    request: requestCheckDomainAvailabilityToTitan,
    success: checkDomainAvailabilityToTitanSuccess,
    failure: checkDomainAvailabilityToTitanFailure,
    reset: resetTitanDomainAvailabilityFlow,
  },
  changeTitanDomain: {
    request: requestChangeTitanDomain,
    success: changeTitanDomainSuccess,
    failure: changeTitanDomainFailure,
  },
  getTitanDomainRedeemData: {
    request: getTitanDomainRedeemDataRequest,
    success: getTitanDomainRedeemDataSuccess,
    failure: getTitanDomainRedeemDataFailure,
    reset: resetTitanDomainRedeemData,
  },
};

export default actions;
